import { render } from "./FormResetPassword.vue?vue&type=template&id=23712de0&scoped=true"
import script from "./FormResetPassword.vue?vue&type=script&lang=js"
export * from "./FormResetPassword.vue?vue&type=script&lang=js"

import "./FormResetPassword.vue?vue&type=style&index=0&id=23712de0&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23712de0"]])

export default __exports__